module.exports = __webpack_public_path__ + "h5/img/global_xg.eec876c3.png";